import defaultConfig from './default.config';
import oldmutualConfig from './oldmutual.config';
import speedyConfig from './speedy.config';
import quickwillConfig from './quickwill.config';
import tebaConfig from './teba.config.js';

const whitelabelConfig = {
  default: defaultConfig,
  quickwill: quickwillConfig,
  speedy: speedyConfig,
  oldmutual: oldmutualConfig,
  teba: tebaConfig,
};

function mergeDeep(...objects) {
  const isObject = obj => obj && typeof obj === 'object';

  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach(key => {
      const pVal = prev[key];
      const oVal = obj[key];

      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = pVal.concat(...oVal);
      } else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = mergeDeep(pVal, oVal);
      } else {
        prev[key] = oVal;
      }
    });

    return prev;
  }, {});
}

function whitelabel(brand) {
  return mergeDeep(whitelabelConfig.default, whitelabelConfig[brand]);
}

// On the Teba domain (or with ?debug_teba=true) the Old Mutual Will build keeps
// its own brand but adopts Teba's authentication block, so login uses the
// industry number and password reset uses SMS. Only the authentication subtree
// is overlaid — logo, theme, copy and navigation stay Old Mutual Will. The
// authentication subtree is pure data, so it is cloned before merging to avoid
// mutating the shared config objects (mergeDeep mutates in place).
function whitelabelForHost(brand, { tebaMode = false } = {}) {
  const base = whitelabel(brand);
  if (!tebaMode) return base;

  const clone = value => JSON.parse(JSON.stringify(value));
  const authentication = mergeDeep(
    {},
    clone(base.authentication),
    clone(whitelabelConfig.teba.authentication)
  );

  return { ...base, authentication };
}

export { whitelabelForHost };
export default whitelabel;
